<template>
  <h-fs-dialog
    :value="show"
    bottom
  >
    <v-card tile light>
      <v-toolbar
        flat
        max-height="56"
        color="grey lighten-4"
      >
        <v-btn
          icon
          color="primary"
          @click.stop="close()"
        >
          <v-icon v-text="icons.close" />
        </v-btn>
        <v-spacer />
        <v-toolbar-title v-text="__('fiscalInformation')" />
        <v-spacer />
        <v-btn
          icon
          color="primary"
          :loading="printing"
          @click.stop="print()"
        >
          <v-icon v-text="icons.print" />
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <h-fiscal-line
          v-for="(line, i) in info"
          :key="i"
          v-bind="line"
        />
      </v-card-text>
    </v-card>
  </h-fs-dialog>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import I18n from '@/Mixins/I18n'
  import Printable from '@/Mixins/Printable'
  import UsesIcons from '@/Mixins/UsesIcons'
  import FranceLog from '@/Models/Static/FiscalCountry/FranceLog'
  import HFsDialog from '@/Components/FullScreenDialog'
  import HFiscalLine from './Line'

  export default {
    mixins: [
      I18n,
      Printable,
      UsesIcons,
    ],

    components: {
      HFsDialog,
      HFiscalLine,
    },

    data: () => ({
      FranceLog,
    }),

    computed: {
      ...mapState('fiscalCountry', [
        'show',
      ]),
      ...mapGetters('fiscalCountry', [
        'info',
      ]),
    },

    methods: {
      close () {
        this.$store.dispatch('fiscalCountry/close')
      },
      print () {
        this.printing = true
        this.initPrinter()

        const left = JSON.stringify({align: 'left'})
        AndroidPrinter.separator('-')
        this.info.forEach(line => {
          AndroidPrinter.text(this.__(line.title), left)
          if (Array.isArray(line.value)) {
            line.value.forEach(subline => {
              AndroidPrinter.text(`  ${subline}`, left)
            })
          } else {
            AndroidPrinter.text(`  ${line.value}`, left)
          }
          AndroidPrinter.separator()
        })
        AndroidPrinter.separator('-')

        Bridge.interfaces.AndroidPrinter.print()
          .then(() => {
            this.$log('Printed', 'Fiscal information')
            this.printing = false
          })
          .catch(() => {
            this.$log('Print error', 'Fiscal information')
            this.$logFrance(this.FranceLog.PRINTER_NOT_AVAILABLE, 'Fiscal information')
            this.$store.dispatch('alert/showError', this.__('printError'))
            this.printing = false
          })
          // the finally method does not work in the current Bridge version
      },
    },
  }
</script>
